import React from 'react';
import { Paper, Box } from '@mui/material';
import { Link } from 'react-router-dom';

type Props = {
  isOpen?: boolean;
  children?: React.ReactNode;
};

export default function Topbar(props: Props): JSX.Element {
  return (
    <Paper sx={{
        position:"fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        textAlign: "left",
      }}
      square={true}>
      <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", padding: "0 1rem"}}>
        <Box sx={{verticalAlign: "middle", display: "inline-block", padding: "2px 0 0 2px"}}>
          <Link to="/dashboard">
            <img style={{ height: "3rem", width: "auto" }} src="/img/Infegy_Logo_FullColor.svg" alt="Infegy Starscape logo" />
          </Link>
        </Box>
        <Box sx={{ display: "inline-block", width:"100%" }}>
        {props.children}
        </Box>
      </Box>
    </Paper>
  );
}